import React, { Component } from 'react';
import { View } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { Images } from '../../Themes';
import BillingTestKeys from '../../Utils/BillingTestKeys.js';

import styles from './NoBills.styles';

class NoBills extends Component {
  render() {
    const { title, titleStyle, subtitle, subtitleStyle, subtitlePLaceholder, theme } = this.props;
    return (
      <View style={styles.container}>
        <VFText
          i18nKey={title}
          style={[styles.title(theme), titleStyle]}
          testKey={BillingTestKeys.noBillsTitleText}
        />
        <VFText
          i18nKey={subtitle}
          style={[styles.subtitle(theme), subtitleStyle]}
          placeHolders={subtitlePLaceholder}
          testKey={BillingTestKeys.noBillsSubtitleText}
        />
      </View>
    );
  }
}

NoBills.defaultProps = {
  image: Images.icClock,
  theme: LightThemeColors,
};

NoBills.propTypes = {
  title: PropTypes.string,
  titleStyle: ViewPropTypes.style,
  subtitle: PropTypes.string,
  subtitleStyle: ViewPropTypes.style,
  subtitlePLaceholder: PropTypes.arrayOf(PropTypes.string),
  theme: PropTypes.object,
};

export default withTheme(NoBills);
